import React, {useEffect, useState} from 'react';
import Header from "../../components/Header";
import {Outlet, useNavigate, useLocation} from 'react-router-dom';
import Sidebar from "../../components/Sidebar";


const AppContainer = () => {

    const [currentContainer, setCurrentContainer] = useState('sideBar.dashboard')
    const navigate = useNavigate();
    const location = useLocation();


    function handleSideBarElementOnClick(currentView) {
        setCurrentContainer(currentView)
    }

    useEffect(() => {
        if (location.pathname === '' || location.pathname === '/') {
            navigate('/dashboard')
        }
    }, [])

    return (
        <div className="flex flex-col md:flex-row">
            {/* Sidebar: full width on mobile, 20% (1/5) on md+ */}
            <div className="w-full md:w-1/5">
                <Sidebar onClick={handleSideBarElementOnClick}/>
            </div>
            {/* Main content: full width on mobile, 80% (4/5) on md+ */}
            <div className="w-full md:w-4/5">
                <Header currentView={currentContainer}/>
                <Outlet/>
            </div>
        </div>
    );
};

export default AppContainer;
